import UserSession from '@/infrastructure/user-session';
import OrganisationDetailsHandler from '@/services/organisation-details-handler';

export default class Bootstrapper {
	public static async bootstrap(): Promise<void> {
		if (UserSession.isValid()) {
			UserSession.keepAlive();

			await OrganisationDetailsHandler.prepareOrganisationDetails();
		} else {
			const error = new Error('No valid user session found.');

			error.name = 'NotAuthorizedException';
			throw error;
		}
	}
}
